import FrontCubeData from '../frontCubeData/index';

function getCubeBeforeUpdateInfo(updateTasks: UpdateTask[]): UpdateTask[] {
    let result: UpdateTask[] = [];

    updateTasks.forEach((task: UpdateTask): void => {
        let oldInfo: UpdateTask = {
            cubeId: task.cubeId,
            updateData: {}
        };

        for (let key in task.updateData) {
            let value: any = FrontCubeData.getValue(task.cubeId, key);

            oldInfo.updateData[key] = value;
        }

        result.push(oldInfo);
    });

    return result;
}

export {
    getCubeBeforeUpdateInfo
};
